import { createFeatureSelector, createSelector, MemoizedSelector } from '@ngrx/store';
import { nameof } from '@symphony-solo/shared/utils/src';
import { IPaymentsFeature } from './payments.feature.state';
import { PaymentsState } from './payments.state';

export const getPaymentsState: MemoizedSelector<IPaymentsFeature, PaymentsState> = createFeatureSelector<PaymentsState>(
  nameof<IPaymentsFeature>('paymentsFeature')
);

export const getIsLoading = createSelector(getPaymentsState, (state: PaymentsState) => state.isLoading);
export const getFailures = createSelector(getPaymentsState, (state: PaymentsState) => state.failures);
export const getPayments = createSelector(getPaymentsState, (state: PaymentsState) => state.payments);
export const getSelectedPayment = createSelector(getPaymentsState, (state: PaymentsState) => state.selectedPayment);
